export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "package_planning": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Planeación por empaques"])},
            "num_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de empaques"])},
            "agro_exporter_brand_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marca"])},
            "size_package_plannings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibre"])}
          }
        }
      },
      "en": {
        "model": {
          "package_planning": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package Planning"])},
            "num_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of packages"])},
            "agro_exporter_brand_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand"])},
            "size_package_plannings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])}
          }
        }
      }
    }
  })
}